import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCsvExportService } from '../utils/abstract-csv-export.service';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';


@Injectable({
    providedIn: 'root',
})
export class NetzbetreiberExportService extends AbstractCsvExportService {

    constructor() {
        super(inject(HttpClient), inject(FileSaverService));
    }

    public exportNetzbetreiber() {
        this.exportCsv('/netzbetreiber/netzbetreiber.csv', FileSaverUsecase.CSV_EXPORT_NETZBETREIBER);
    }
}
